import React from 'react';
import { TextFieldProps } from 'mui-rff';
import cc from 'classnames';
import Input from '../Input';

import styles from './Textarea.module.css';

const Textarea = ({
  ...props
}: TextFieldProps) => (
  <Input
    multiline
    InputProps={{
      disableUnderline: true,
    }}
    {...props}
    className={cc(
      // eslint-disable-next-line css-modules/no-undef-class
      styles.input, styles.text,
    )}
  />
);

export default Textarea;
